import { candidateRowStyles } from '@pages/Teams.styles';

/** The download control: one button, which opens the layouts. */
export const controlStyles = {
  display: 'flex',
  alignItems: 'center',
  // The button sits in the wrapper its tooltip needs while the button is disabled.
  '& > span': { display: 'flex' },
};

/** The choices of the layout dialog: what scrolls between its header and its buttons. */
export const optionListStyles = {
  overflowY: 'auto',
};

/** One choice, drawn as a row of the member picker (`Teams.styles.ts`) and a button across the dialog. */
export const optionStyles = {
  ...candidateRowStyles,
  width: '100%',
  gap: 1.5,
  justifyContent: 'flex-start',
  textAlign: 'left',
  // Shown only where the keyboard put the reader on the option, and drawn inside the row:
  // the list cuts off what stands outside it.
  '&.Mui-focusVisible': { outline: '2px solid', outlineColor: 'primary.light', outlineOffset: -2 },
};

/** Under a layout's description: whose brand it is printed with, for a reader in several teams. */
export const optionNoteStyles = {
  mt: 0.25,
  fontSize: 12.5,
  color: 'text.secondary',
  fontStyle: 'italic',
};

/** The same note over the designs, where it is about all of them: a line of the list, not of an option. */
export const designsNoteStyles = {
  ...optionNoteStyles,
  mt: 0,
  px: 2.5,
  pt: 1.5,
};

/** In the designs' place when their list could not be read: a line of the list, under the layouts. */
export const designsFailedStyles = {
  px: 2.5,
  py: 1.5,
  fontSize: 13,
  color: 'text.secondary',
  // The last layout draws the line under itself only when a design follows it.
  borderTop: '1px solid',
  borderColor: 'divider',
};

export const optionIconStyles = {
  display: 'flex',
  flexShrink: 0,
  color: 'text.secondary',
};

/** The owner over its designs. Not in capitals: a team's name is text its members wrote. */
export const ownerHeadingStyles = {
  px: 2.5,
  pt: 1.5,
  pb: 0.5,
  fontSize: 12.5,
  fontWeight: 600,
  color: 'text.secondary',
};
